/**
 * Enum for store branch type
 * @readonly
 * @enum {String}
 */
export default Object.freeze({
  BB: 'bb',
  B_CAMPUS: 'b-campus',
  BKK: 'bkk',
  BANANA: 'banana',
  BANANA_MOBILE: 'banana-mobile',
  BANANA_OUTLET: 'banana-outlet',
  B_PLAY: 'b-play',
  COM7: 'com7',
  E_QUIP: 'e-quip',
  HUAWEI: 'huawei',
  KKP: 'kkp',
  OPPO: 'oppo',
  REALME: 'realme',
  SAMSUNG: 'samsung',
  STUDIO_7: 'studio-7',
  VIVO: 'vivo',
  XIAOMI: 'xiaomi',

  // EXHIBITION: 'exhibition',
  // ICARE: 'icare',
  // USTORE: 'ustore',
})
